import type { CandidateEmailData } from '@jobilla/nexus-sdk'
import type { ScanStatus } from '../../../shared/scan-status'

export interface EmailContact {
	name: string
	email: string
}

export interface EmailAttachment {
	id: string
	name: string
	size: number
	type: string
	url: string | null
	scanStatus: ScanStatus
	scanSignature: string | null
}

export interface EmailReadBy {
	userId: string
	readAt: Date
}

export interface Email {
	id: string
	subject: string
	from: EmailContact
	to: EmailContact
	body: string
	sentAt: Date
	isRead: boolean
	isFromCandidate: boolean
	attachments: EmailAttachment[]
	readBy: EmailReadBy[]
}

export type ComposeMode = 'new' | 'reply'

export const DUMMY_RECRUITER: EmailContact = {
	name: 'Recruiter',
	email: 'recruiter@company.com',
}

export function mapApiEmailToEmail(
	apiEmail: CandidateEmailData,
	candidateContact: EmailContact,
	currentUserRecruiter: EmailContact = DUMMY_RECRUITER,
): Email {
	const isFromCandidate = apiEmail.direction === 'inbound'

	const senderContact: EmailContact = isFromCandidate
		? candidateContact
		: {
			name: apiEmail.senderName ?? currentUserRecruiter.name,
			email: apiEmail.senderEmail ?? currentUserRecruiter.email,
		}

	return {
		id: apiEmail.id,
		subject: apiEmail.subject ?? '',
		body: apiEmail.body,
		sentAt: new Date(apiEmail.sentAt ?? apiEmail.createdAt),
		isRead: apiEmail.isRead,
		isFromCandidate,
		from: senderContact,
		to: isFromCandidate ? currentUserRecruiter : candidateContact,
		attachments: apiEmail.attachments.map((att) => ({
			id: att.id,
			name: att.name,
			size: att.size,
			type: att.type ?? '',
			url: att.url,
			scanStatus: att.scanStatus,
			scanSignature: att.scanSignature,
		})),
		readBy: apiEmail.readBy.flatMap((read) =>
			read.readAt === null ? [] : [{ userId: read.userId, readAt: new Date(read.readAt) }]
		),
	}
}
